import { render, staticRenderFns } from "./vue-simple-spinner.vue?vue&type=template&id=40e11c9a"
import script from "./vue-simple-spinner.vue?vue&type=script&lang=js"
export * from "./vue-simple-spinner.vue?vue&type=script&lang=js"
import style0 from "./vue-simple-spinner.vue?vue&type=style&index=0&id=40e11c9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports